import { alpha, useTheme } from '@mui/material/styles'
import { Box, Divider, Drawer, Stack, Typography, Tooltip, IconButton } from '@mui/material'
import { bgBlur } from '../../../utils/cssStyles'
import { NAV } from '../../../config-global'
import { Iconify } from '../../Iconify'
import Scrollbar from '../../scrollbar'
import { useSettingsContext } from '../SettingsContext'
import Block from './Block'
import BadgeDot from './BadgeDot'
import ModeOptions from './ModeOptions'
import LayoutOptions from './LayoutOptions'
import StretchOptions from './StretchOptions'
import ContrastOptions from './ContrastOptions'
import DirectionOptions from './DirectionOptions'
import FullScreenOptions from './FullScreenOptions'
import ColorPresetsOptions from './ColorPresetsOptions'
import { _themeDefaults } from '../../../utils/dataDefaults'

const SPACING = 2.5

export default function SettingsDrawer() {
  const {
    themeMode,
    themeLayout,
    themeStretch,
    themeContrast,
    themeDirection,
    themeColorPresets,
    onResetSetting,
    showDrawer,
    setShowDrawer
  } = useSettingsContext()

  const theme = useTheme()

  const notDefault =
    themeMode !== _themeDefaults.themeMode ||
    themeLayout !== _themeDefaults.themeLayout ||
    themeStretch !== _themeDefaults.themeStretch ||
    themeContrast !== _themeDefaults.themeContrast ||
    themeDirection !== _themeDefaults.themeDirection ||
    themeColorPresets !== _themeDefaults.themeColorPresets

  return (
      <Drawer
        anchor="right"
        open={showDrawer}
        onClose={() => setShowDrawer(false)}
        BackdropProps={{ invisible: true }}
        PaperProps={{
          sx: {
            ...bgBlur({ color: theme.palette.background.default, opacity: 0.9 }),
            width: NAV.W_BASE,
            boxShadow: `-24px 12px 40px 0 ${alpha(
              theme.palette.mode === 'light' ? theme.palette.grey[500] : theme.palette.common.black,
              0.16
            )}`,
          },
        }}
      >
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
          sx={{ py: 2, pr: 1, pl: SPACING }}
        >
          <Typography variant="subtitle1" sx={{ flexGrow: 1 }}>
            Ajustes
          </Typography>

          <Tooltip title="Reset">
            <Box sx={{ position: 'relative' }}>
              {notDefault && <BadgeDot />}
              <IconButton onClick={onResetSetting}>
                <Iconify icon="ic:round-refresh" />
              </IconButton>
            </Box>
          </Tooltip>

          <IconButton onClick={() => setShowDrawer(false)}>
            <Iconify icon="eva:close-fill" />
          </IconButton>
        </Stack>

        <Divider sx={{ borderStyle: 'dashed' }} />

        <Scrollbar sx={{ p: SPACING, pb: 0 }}>
          <Block title="Tema">
            <ModeOptions />
          </Block>

          <Block title="Contraste">
            <ContrastOptions />
          </Block>

          <Block title="Dirección menú">
            <DirectionOptions />
          </Block>

          <Block title="Modo menú">
            <LayoutOptions />
          </Block>

          <Block title="Estirar contenido" tooltip="Aplicable para pantallas extra grandes > 1600px (xl)">
            <StretchOptions />
          </Block>

          <Block title="Color principal">
            <ColorPresetsOptions />
          </Block>
        </Scrollbar>

        <Box sx={{ p: SPACING, pt: 0 }}>
          <FullScreenOptions />
        </Box>
      </Drawer>
  )
}
